export const MAX_PAYMENT_PROOFS = 1;
export const MAX_PROOF_BYTES = 10 * 1024 * 1024;

export function extractUploadUrl(up) {
  return up?.url || up?.imageUrl || up?.data?.url || "";
}

/** Stable dedupe key so signed + unsigned URLs for the same asset collapse. */
function proofDedupeKey(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  try {
    const u = new URL(raw);
    return `${u.origin}${u.pathname}`.toLowerCase();
  } catch {
    return raw.split("?")[0].split("#")[0].toLowerCase();
  }
}

/** Single proof URL string for display (no arrays). */
export function collectProofUrl(record) {
  if (!record || typeof record !== "object") return "";
  const direct =
    record.paymentProofUrl ||
    record.payment_proof_url ||
    "";
  if (direct && typeof direct === "string") return direct.trim();

  // Legacy array fields during transition
  const extra = record.paymentProofUrls ?? record.payment_proof_urls ?? [];
  if (Array.isArray(extra) && extra[0]) return String(extra[0]).trim();
  if (typeof extra === "string" && extra.trim()) {
    try {
      const parsed = JSON.parse(extra);
      if (Array.isArray(parsed) && parsed[0]) return String(parsed[0]).trim();
    } catch {
      return extra.trim();
    }
  }
  return "";
}

/** @deprecated use collectProofUrl — kept for gallery components expecting an array */
export function collectProofUrls(record) {
  const one = collectProofUrl(record);
  return one ? [one] : [];
}

export async function uploadPaymentProofFile(file, uploadSingle) {
  if (!file) throw new Error("Payment proof image is required.");
  const up = await uploadSingle(file);
  const url = extractUploadUrl(up);
  if (!url) throw new Error("Failed to upload payment proof.");
  return url;
}

/** Upload first file only (single-image mode). */
export async function uploadPaymentProofFiles(files, uploadSingle) {
  const list = Array.isArray(files) ? files.filter(Boolean) : [];
  const file = list[0];
  if (!file) throw new Error("Payment proof image is required.");
  const url = await uploadPaymentProofFile(file, uploadSingle);
  return { urls: [url], objectKeys: [], url };
}

export { proofDedupeKey };
